/* eslint-disable react/prop-types */

import { AutoComplete, Dropdown, Menu, Radio, Select, Tooltip } from 'antd';
import { ProfileLogo } from '../../ambient_solo/components/baseComponents';
import {
  CloseOutlined,
  HistoryOutlined,
  AudioOutlined,
  UploadOutlined,
} from '@ant-design/icons';
import {
  CalendarIcon,
  ExpandIcon,
  ListIcon,
  ManageViewsIcon,
  PlusIcon,
  RecentSearchIcon,
  SearchIcon,
  TagIcon,
  PatientIcon,
} from '../../../icons';
import ModalPopup from '../../../components/pageComponents/ModalPopup';
import AmbientMicIcon from 'src/assets/ambient_mic.svg';
import { storeInLocal } from '../../../lib/storage';
import AppointmentsCSVUploaderHistory from './AppointmentsCSVUploaderHistory';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { getAppointmentByFilter } from '../../../store';
import { useAuth, useFeatureEntitlements } from '@frontegg/react';
import { SavedSearchModal } from '../../../components/pageComponents/SaveSearch.Modal';
import { ManageViewModal } from '../../../components/pageComponents/ManageView.Modal';
import ConvertAppointmentToAuraEncounterModal from './ConvertAppointmentToAuraEncounterModal';
import AppointmentsCSVUploader from './AppointmentsCSVUploader';
import { AddNewAppointment } from './AddNewAppointment';
import {
  getAppointmentAllEndDateFilter,
  getAppointmentAllStartDateFilter,
} from '../utils/helpers';
import { AURA_ONLY_APPOINTMENT_TYPE } from '../utils/constants';
import { addRecentSearchAction } from '../../../store/actions/appointment.action';
import { showToastSuccess } from '../../../utilities/toast';
import { analytics } from 'src/services';
import { useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import { useState, useEffect } from 'react';

const AppointmentTopFilterBar = ({
  setShowProfileLogo,
  selectedPractitioners,
  setSelectedPractitioners,
  practitionersAndPatients,
  currentPractitioner,
  isTenantMatching,
  setSelectDates,
  setShowUpload,
  onChangeHandler,
  showProfileLogo,
  setpractitionerSearchKeyword,
  hasMultiplePractitionersWithSameName,
  appointmentsView,
  showDropdown,
  showNoData,
  setPatientSearchKeyword,
  currentDate,
  handleMonthChange,
  handleYearChange,
  isfilterOn,
  filterValue,
  setFilterValue,
  resetDateFilter,
  setResetDateFilter,
  selectDates,
  setEndDate,
  selectedFilters,
  renameTitle,
  myAppointments,
  selectedTitle,
  handleCurrentPractitionerNext7Days,
  handleMangeViews,
  recentSearchList,
  showModal,
  CSVUploadEnabledForCurrentUser,
  setDefaultAppointmentType,
  // setUploadKey,
  setShowUploadHistory,
  filterOptions,
  setIsFilterOn,
  setShowNoData,
  setShowDropdown,
  handleReset,
  setStartIndex,
  setFilteredPatientNames,
  setAppointmentsView,
  setMyAppointments,
  setDateValue,
  setSelectedFilters,
  filteredPatientNames,
  startIndex,
  performFuzzySearch,
  isCustomSelected,
  handleAddLabel,
  handleRecentSearchSelect,
  setSelectedTitle,
  isModalVisible,
  setDuplicateError,
  duplicateError,
  handleSaveAppDuplicate,
  handleSaveView,
  setRenameTitle,
  parseStoredNames,
  handleCloseView,
  isMangeViewOpen,
  handleCloseManageView,
  showConvertAppointmentToAuraModal,
  hideConvertAppointmentToAuraModal,
  selectedAppointmentForAuraEncounter,
  isModalOpen,
  setIsModalOpen,
  handleCancel,
  defaultAppointmentType,
  showUploadHistory,
  showUpload,
  isDefaultAppointmentView,
  setDefaultAppointmentView,
  setToStore,
}) => {
  const dispatch = useDispatch();
  const { user } = useAuth();

  const { isEntitled: hasVCAProcessedWorkflowAccess } = useFeatureEntitlements(
    'vca-processed-status'
  );
  const { allPractitionersNames, settingsOrgValue } = useSelector(
    (state) => state?.appointmentState
  );
  const nonVCAIntakeStatus = 'Aura encounter';
  const loggedInUserName = currentPractitioner?.practitioner_name;
  const loggedInUserId = currentPractitioner?.practitioner_id;

  const handleTabChange = (key) => {
    if (key === 'LIST') {
      localStorage.setItem('appointment_view', 'LIST');
      handleResetDateAndPatientFilters('reset');
    } else {
      localStorage.setItem('appointment_view', 'CALENDAR');
      setSelectedPractitioners([loggedInUserId]);
      setFilterValue({
        ...filterValue,
        doctorName: loggedInUserId ? [loggedInUserId] : [],
        practitionerNames: loggedInUserName ? [loggedInUserName] : [],
        patientName: '',
        patientId: '',
      });
      localStorage.removeItem(
        `${currentPractitioner?.org_uuid}_filter_patient_name`
      );
      localStorage.removeItem('filterValueOnreload');
      setToStore(false);
      localStorage.removeItem(
        `${currentPractitioner?.org_uuid}_isPatientSelected`
      );
      if (filterValue?.patient_name) {
        setFilterValue({ patient_name: '', ...filterValue });
      }
      setFilteredPatientNames([]);
      setPatientSearchKeyword('');
      setStartIndex(1000);
    }
    setAppointmentsView(key);
    analytics.track(`Switched Appointments View to: ${key}`, {
      email: user?.email,
    });
  };

  const addAppointmentOptions = () => {
    return (
      <Menu>
        <Menu.Item
          className="font-sans"
          key="bulk-upload"
          onClick={() => {
            setShowUpload(true);
            // setUploadKey((prevKey) => prevKey + 1); // Increment the key to trigger re-render
            analytics.track('Clicked Bulk Upload Appointments', {
              email: user?.email,
            });
          }}
        >
          <UploadOutlined className="mr-1" /> Bulk upload
        </Menu.Item>
        <Menu.Item
          className="font-sans"
          key="bulk-upload-history"
          onClick={() => {
            setShowUploadHistory(true);
            analytics.track('Clicked Bulk Upload Appointments History', {
              email: user?.email,
            });
          }}
        >
          <HistoryOutlined className="mr-1" /> Bulk upload history
        </Menu.Item>
        <Menu.Item
          className="font-san flex items-center"
          key="add-aura-encounter"
          onClick={() => {
            setDefaultAppointmentType(AURA_ONLY_APPOINTMENT_TYPE);
            setTimeout(() => {
              showModal();
            }, 0);
            analytics.track('Clicked Add Aura encounter appointment', {
              email: user?.email,
            });
          }}
        >
          <span className="flex items-center">
            <img className="mr-1" src={AmbientMicIcon} alt="mic logo" />
            Add Aura encounter
          </span>
        </Menu.Item>
      </Menu>
    );
  };

  const handleSetDefault = (selectedRecord) => {
    const updatedSearches = (recentSearchList?.search_preference || []).map(
      (record) => {
        if (record.id === selectedRecord.id) {
          return { ...record, isDefaultAppointmentView: true };
        }

        return { ...record, isDefaultAppointmentView: false };
      }
    );

    dispatch(addRecentSearchAction(updatedSearches, 'appointments'));

    showToastSuccess('Default preference updated');
  };

  const handleResetDateAndPatientFilters = async (type) => {
    localStorage.removeItem(`${currentPractitioner?.org_uuid}_dateValue`);
    localStorage.removeItem(`${currentPractitioner?.org_uuid}_selectDates`);
    localStorage.removeItem(`${currentPractitioner?.org_uuid}_startDate`);
    localStorage.removeItem(`${currentPractitioner?.org_uuid}_endDate`);
    setSelectDates([null, null]);
    setMyAppointments('');
    setIsFilterOn(true);
    setResetDateFilter(true);

    localStorage.removeItem(
      `${currentPractitioner?.org_uuid}_filter_patient_name`
    );
    localStorage.setItem(
      `${currentPractitioner?.org_uuid}_selectedFilters`,
      'Today'
    );
    setSelectedFilters('Today');
    setDateValue('Today');
    setPatientSearchKeyword('');
    setFilteredPatientNames([]);

    const startDate = type === 'reset' ? moment().format('YYYY-MM-DD') : '';
    const endDate = type === 'reset' ? moment().format('YYYY-MM-DD') : '';
    const datefilter = type === 'reset' ? 'Today' : 'All time';
    const patientName = type === 'patientReset' ? filterValue?.patientName : '';
    const patientId = type === 'patientReset' ? filterValue?.patientId : '';

    const practitioner_ids = filterValue?.doctorName;
    setFilterValue({
      patientName,
      doctorName: filterValue?.doctorName || [],
      startDate,
      endDate,
      datefilter,
      status: filterValue?.status || '',
      patientId,
    });

    await dispatch(
      getAppointmentByFilter(
        practitioner_ids,
        patientName,
        getAppointmentAllStartDateFilter(startDate) || 'All Time',
        getAppointmentAllEndDateFilter(endDate) || 'All Time',
        filterValue?.status,
        'normal',
        startIndex,
        patientId,
        'start_date',
        'desc'
      )
    );
    setStartIndex(25);
  };

  const statusOptions = [
    {
      title: 'All',
      value: 'intake-All',
      className:
        'flex justify-center items-center h-8 rounded-full hover:bg-[#f7f7f7] text-xs',
    },
    {
      title: 'Completed',
      value: 'intake-Completed',
      className:
        'text-[#1ec990] bg-[#eefaf4] flex items-center justify-center rounded-full hover:bg-[#A2EFC9]  h-8 text-xs',
    },
    ...(hasVCAProcessedWorkflowAccess
      ? [
          {
            title: 'Processed',
            value: 'intake-processed',
            className:
              'text-[#4d38ca] bg-[#edf0ff] flex items-center justify-center rounded-full hover:bg-[#c7cefe] status-options h-8 text-xs',
          },
        ]
      : []),
    {
      title: 'In Progress',
      value: 'intake-InProgress',
      className:
        'text-[#ff6f00] bg-[#ffe1ca] flex items-center justify-center rounded-full hover:bg-[#F7CFB1] text-xs h-8',
    },
    {
      title: 'Not Started',
      value: 'intake-New',
      className:
        'text-[#5a8dda] bg-[#e7f1ff] flex items-center justify-center rounded-full hover:bg-[#BCD4F7] status-options h-8 text-xs',
    },
    {
      title: nonVCAIntakeStatus,
      value: 'intake-Unavailable',
      className:
        'text-[#018749] bg-[#caffca] flex items-center justify-center rounded-full hover:bg-[#a8ffa8] status-options px-1 h-8 text-xs',
    },
    {
      title: 'Partial Summary',
      value: 'intake-partial_completed',
      className:
        'text-[#ff6f00] bg-[#ffe1ca] flex items-center justify-center rounded-full hover:bg-[#F7CFB1] px-3 h-8 text-xs',
    },
  ];

  const inVisitStatusOptions = [
    {
      title: 'All',
      value: 'invisit-All',
      className:
        'flex justify-center items-center h-8 rounded-full hover:bg-[#f7f7f7] text-xs',
    },
    {
      title: 'Completed',
      value: 'invisit-completed',
      className:
        'text-[#1ec990] bg-[#eefaf4] flex items-center justify-center rounded-full hover:bg-[#A2EFC9] h-8 px-3 text-xs',
    },
    {
      title: 'In Progress',
      value: 'invisit-inprogress',
      className:
        'text-[#ff6f00] bg-[#ffe1ca] flex items-center justify-center rounded-full hover:bg-[#F7CFB1] h-8 px-3 text-xs',
    },
    {
      title: 'Not Started',
      value: 'invisit-new',
      className:
        'text-[#5a8dda] bg-[#e7f1ff] flex items-center justify-center rounded-full hover:bg-[#BCD4F7] status-options h-8 px-3 text-xs',
    },
  ];

  const getFilteredPractitioners = () => {
    if (
      isEmpty(practitionersAndPatients?.practitioner) ||
      isEmpty(allPractitionersNames) ||
      !allPractitionersNames.filter
    ) {
      return [];
    }
    // Create a Set of practitioner_ids that have is_shown: true
    const shownPractitionerIds = new Set(
      allPractitionersNames
        ?.filter((practitioner) => practitioner.is_shown === true)
        ?.map((practitioner) => practitioner.practitioner_id)
    );

    // Add currentPractitioner if settingsOrgValue has_appointments is true
    if (
      settingsOrgValue?.has_appointments &&
      currentPractitioner?.practitioner_id
    ) {
      shownPractitionerIds.add(currentPractitioner.practitioner_id);
    }

    return (
      practitionersAndPatients?.practitioner?.filter((practitioner) =>
        shownPractitionerIds.has(practitioner.practitioner_id)
      ) || []
    );
  };

  const filteredPractitioners = getFilteredPractitioners();

  // Mobile detection for responsive button text
  const [isShowAppointmentTooltip, setIsShowAppointmentTooltip] = useState(
    window.innerWidth < 1400
  );

  useEffect(() => {
    const handleResize = () => {
      setIsShowAppointmentTooltip(window.innerWidth < 1400);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <>
      <div className="flex justify-between flex-wrap gap-2">
        <div className="flex gap-1.5 items-start">
          {/* Practitioner Dropdown : Start */}
          <div
            className={`w-full  md:w-44  overflow-x-auto drop-shadow-sm bg-white rounded-xl  text-sm practitioner-dropdown flex items-center ${appointmentsView === 'LIST' ? 'lg:w-48 xl:w-40' : 'lg:w-52 xl:w-52 2xl:w-72'} `}
            onMouseDown={() => setShowProfileLogo(true)}
            id="PractitionerFilter"
          >
            <Select
              mode="multiple"
              dropdownStyle={{
                width: '275px',
              }}
              variant="borderless"
              className={`placeholder border-none w-full font-sans items-center focus:outline-none py-1 $${
                selectedPractitioners === 0 ? 'h-10 flex items-center' : ' '
              }`}
              filterOption={(inputValue, option) =>
                option.label.toLowerCase().indexOf(inputValue.toLowerCase()) !==
                -1
              }
              placeholder={
                filteredPractitioners?.length > 0
                  ? 'Practitioners'
                  : 'Loading...'
              }
              onDropdownVisibleChange={(open) => {
                setShowProfileLogo(open);
              }}
              value={
                filterOptions?.doctorNames?.length > 0 &&
                filteredPractitioners?.length > 0 &&
                isTenantMatching
                  ? selectedPractitioners
                  : []
              }
              onChange={(value) => {
                setpractitionerSearchKeyword(value);
                analytics.track('Selected Practitioner Filter', {
                  practitioner_name: value,
                  email: user?.email,
                });
                onChangeHandler(value, 'doctorName');
                setSelectedPractitioners(value);
              }}
              optionFilterProp="label"
              showSearch
            >
              {filteredPractitioners?.map((names) => (
                <Select.Option
                  key={names.id}
                  value={names.practitioner_id}
                  email={names.email}
                  label={names.practitioner_firstName}
                >
                  <div className="font-sans flex">
                    <div className="flex items-center">
                      {Array.isArray(selectedPractitioners) &&
                        !selectedPractitioners?.includes(
                          names?.practitioner_id
                        ) &&
                        showProfileLogo && (
                          <ProfileLogo
                            name={`${names.first_name} ${names.last_name}`}
                            className={
                              'profile-popover-logo mr-1 sm:mr-2 lg:mr-3'
                            }
                          />
                        )}
                      <div className="">
                        {names.practitioner_firstName}
                        {hasMultiplePractitionersWithSameName(
                          names.practitioner_firstName
                        ) && (
                          <div
                            style={{
                              color: 'grey',
                              fontSize: 'smaller',
                              fontFamily: 'Poppins',
                            }}
                          >
                            {selectedPractitioners &&
                              !selectedPractitioners.includes(
                                names?.practitioner_id
                              ) && <span>{names.practitioner_email}</span>}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </Select.Option>
              ))}
            </Select>
          </div>
          {/* Practitioner Dropdown : End  */}

          {/* Patient Search Auto complete : start */}
          {appointmentsView === 'LIST' && (
            <div
              className="w-full md:w-36 2xl:w-52 drop-shadow-sm bg-white rounded-xl"
              id="PatientSearch"
            >
              <AutoComplete
                variant="borderless"
                className="border-none font-sans h-10 text-base flex items-center w-full border-0 focus:outline-none placeholder-gray-500 pr-4"
                id="PatientSearchField"
                style={{
                  WebkitTextFillColor: 'gray',
                }}
                options={
                  showDropdown &&
                  (showNoData
                    ? [
                        {
                          value: 'No data',
                          label: 'No data',
                          disabled: true,
                        },
                      ]
                    : filteredPatientNames.map((patient) => ({
                        ...patient,
                        key: patient.patient_id,
                        value: `${patient.value}_${patient.patient_id}`,
                        label: (
                          <div>
                            <div>{patient.value}</div>
                            <div className="flex flex-row justify-start gap-2">
                              <div className="text-[11px] text-[#777777]">
                                DOB: {patient.patient_dob}
                              </div>
                              <div className="text-[11px] text-[#777777]">
                                Patient ID: {patient.patient_id}
                              </div>
                            </div>
                            {patient?.ehr_id && (
                              <div className="flex flex-row justify-start gap-2">
                                <Tooltip
                                  title={
                                    patient.ehr_id.length > 15
                                      ? patient.ehr_id
                                      : ''
                                  }
                                  className="text-[11px] text-[#777777]"
                                >
                                  <div className="text-[11px] text-[#777777]">
                                    EHR/MRN ID:{' '}
                                    {patient.ehr_id.length > 15
                                      ? `${patient.ehr_id.substring(0, 15)}...`
                                      : patient.ehr_id}
                                  </div>
                                </Tooltip>
                              </div>
                            )}
                            {patient.appointment_date && (
                              <div
                                className={`text-[11px] ${
                                  moment(patient.appointment_date).isBefore(
                                    moment(),
                                    'day'
                                  )
                                    ? 'text-[#ff0000]'
                                    : 'text-[#16a878]'
                                }`}
                              >
                                {moment(patient.appointment_date).isBefore(
                                  moment(),
                                  'day'
                                )
                                  ? `Past appt.: ${patient.appointment_date}`
                                  : `Next appt.: ${patient.appointment_date}`}
                              </div>
                            )}
                          </div>
                        ),
                      })))
                }
                placeholder="Patient"
                filterOption={false}
                value={
                  isfilterOn
                    ? filterValue?.patientName
                      ? filteredPatientNames.find(
                          (opt) => opt.id === filterValue.patientName
                        )?.id || filterValue?.patientName
                      : ''
                    : ''
                }
                suffixIcon={
                  isfilterOn && filterValue?.patientName ? (
                    <CloseOutlined
                      onClick={() => {
                        setIsFilterOn(false);
                        onChangeHandler('', 'patientName');
                        storeInLocal(
                          `${currentPractitioner?.org_uuid}_isPatientSelected`,
                          false
                        );
                        setPatientSearchKeyword('');
                        setShowDropdown(false);
                        setShowNoData(false);
                      }}
                      style={{
                        cursor: 'pointer',
                      }}
                      className="hover:text-gray-700 transition-colors duration-200"
                    />
                  ) : (
                    <SearchIcon />
                  )
                }
                onChange={(value, option) => {
                  setPatientSearchKeyword(option?.id || value);
                  setShowDropdown(false);
                  // isfilterOn Set to true only if value is not empty
                  setIsFilterOn(!!option?.id || !!value);
                  // Filter patient names based on user input
                  const filteredNames = performFuzzySearch(option?.id || value);

                  // Set the showNoData flag if there are no matching names
                  setShowNoData(filteredNames?.length === 0);
                  setFilteredPatientNames(filteredNames);

                  // If the user tries to select "No data," clear the selection
                  if (
                    option?.id
                      ? option?.id?.toLowerCase() === 'no data'
                      : value?.toLowerCase() === 'no data'
                  ) {
                    onChangeHandler('', 'patientName');
                  } else {
                    onChangeHandler(
                      option?.id || value,
                      'patientName',
                      null,
                      option?.patient_id
                    );
                    setShowDropdown(true);
                  }
                }}
                dropdownStyle={{
                  width: '232px',
                }}
              />
            </div>
          )}
          {/* Patient Search Auto complete : end */}

          {/* Date filter dropdown : start */}
          {appointmentsView === 'LIST' && (
            <div
              className=""
              style={{
                position: 'relative',
                zIndex: '10',
              }}
            >
              <ModalPopup
                currentDate={currentDate}
                handleMonthChange={handleMonthChange}
                handleYearChange={handleYearChange}
                onChangeHandler={onChangeHandler}
                dateValue={filterValue?.datefilter}
                setFilterValue={setFilterValue}
                filterValue={filterValue}
                resetDateFilter={resetDateFilter}
                setResetDateFilter={setResetDateFilter}
                selectDates={selectDates}
                setSelectDates={setSelectDates}
                setEndDate={setEndDate}
                setSelectedFilters={setSelectedFilters}
                selectedFilters={selectedFilters}
              />
            </div>
          )}
          {/* Date filter dropdown : end */}

          {/* Status filter dropdown : start */}
          <div
            className={`w-full bg-white rounded-xl h-10 drop-shadow-sm ${appointmentsView === 'LIST' ? 'lg:w-44 2xl:w-52 ' : 'lg:w-64 xl:w-52 2xl:w-64'}`}
          >
            <Dropdown
              arrow={true}
              trigger={['click']}
              menu={{
                items: [
                  {
                    key: 'intakeStatus',
                    label: (
                      <div className="flex items-center gap-1">
                        <PatientIcon />
                        Patient Intake
                      </div>
                    ),
                    children: statusOptions.map((option) => ({
                      key: option.value,
                      label: (
                        <div className={`${option.className}`}>
                          {option.title}
                        </div>
                      ),
                      value: option.value,
                    })),
                    popupClassName: 'appointment-limited-submenu',
                  },
                  {
                    key: 'inVisitStatus',
                    label: (
                      <div className="flex items-center gap-2">
                        <AudioOutlined />
                        In-Visit
                      </div>
                    ),
                    children: inVisitStatusOptions.map((option) => ({
                      key: option.value,
                      label: (
                        <div className={`${option.className}`}>
                          {option.title}
                        </div>
                      ),
                      value: option.value,
                    })),
                    popupClassName: 'appointment-limited-submenu',
                  },
                ],
                onClick: ({ key, keyPath, domEvent }) => {
                  domEvent.stopPropagation();
                  const type = keyPath[1];
                  if (type === 'intakeStatus') {
                    onChangeHandler(key, 'status');
                  } else if (type === 'inVisitStatus') {
                    onChangeHandler(key, 'status');
                  }
                },
              }}
              placement="bottomLeft"
            >
              <div className="font-normal text-xs text-black flex justify-between items-center cursor-pointer px-3">
                <div className="flex justify-between w-full">
                  <span className="pt-3">Status</span>
                  <div className="w-full mx-2 pt-1">
                    {filterValue?.status
                      ? (() => {
                          const [type] = filterValue.status.split('-');
                          const options =
                            type === 'intake'
                              ? statusOptions
                              : inVisitStatusOptions;
                          const matchedStatus = options.find(
                            (opt) => opt.value === filterValue.status
                          );

                          return matchedStatus ? (
                            <div className={matchedStatus.className}>
                              {matchedStatus.title}
                            </div>
                          ) : (
                            ''
                          );
                        })()
                      : ''}
                  </div>
                </div>
                <ExpandIcon
                  className={`${filterValue?.status === '' ? 'mt-3' : 'mt-1'}`}
                  fill={'#000000'}
                />
              </div>
            </Dropdown>
            {/* <label
              htmlFor="status"
              className="custom-label ml-1 text-sm text-black whitespace-nowrap "
            >
              Status
            </label>
            <div className="flex flex-col md:flex-row gap-2 justify-between items-center flex-nowrap ">
              <div className=" grow shrink-0 w-full" id="StatusFilter">
                <TreeSelectDropdown
                  suffixIcon={
                    <ExpandIcon
                      fill={'#000000'}
                      className="-mr-4 absolute right-0"
                    />
                  }
                  name="statusOptions"
                  showSearch={false}
                  variant='borderless'
                  className="!w-20 md:!w-24 lg:!w-26 xl:!w-32 bg-transparent border-none focus:border-none rounded-xl -ml-4 caret-transparent flex items-center hover:bg-transparent -mb-0 text-center"
                  placeholder={'All'}
                  value={
                    isfilterOn && filterValue?.status !== null
                      ? filterValue?.status
                      : 'All'
                  }
                  options={statusOptions}
                  onChange={(value) => onChangeHandler(value, 'status')}
                  popupClassName={'!w-36'}
                ></TreeSelectDropdown>
              </div>
            </div> */}
          </div>
          {/* Status filter dropdown : end */}

          {/* Recent filter search : start */}
          <div
            className="w-full md:w-36 lg:w-44 bg-white xl:w-44 2xl:w-44 h-10 flex items-center drop-shadow-sm rounded-xl text-sm practitioner-dropdown justify-around "
            id="CustomFilter"
          >
            <div className="ml-2">
              <RecentSearchIcon />
            </div>

            <Select
              dropdownStyle={{
                width: '300px',
              }}
              variant="borderless"
              suffixIcon={<ExpandIcon fill={'#000000'} className="" />}
              className="border-none truncate font-sans h-10 text-base flex items-center w-full border-0 focus:outline-none pr-4"
              value={
                renameTitle || myAppointments || selectedTitle || 'Custom views'
              }
              optionFilterProp="label"
              showSearch={false}
            >
              <Select.Option disabled key="next-7-days">
                {/* check */}
                <button
                  type="button"
                  className="w-full py-2 px-1 hover:bg-gray-100 rounded-md text-left"
                  onClick={(e) => {
                    handleCurrentPractitionerNext7Days();
                    const newValue = 'My appointments in next 7 days';
                    setMyAppointments(newValue);
                    localStorage.setItem(
                      `${currentPractitioner?.org_uuid}_myAppointments`,
                      newValue
                    );
                    e.preventDefault();
                    e.stopPropagation();
                  }}
                >
                  <div className="text-gray-700">
                    My appointments in next 7 days
                  </div>
                </button>
              </Select.Option>

              {!isCustomSelected && (
                <Select.Option disabled key="save-view">
                  <div className="">
                    <button
                      type="button"
                      className="flex items-center py-2 px-1 hover:bg-gray-100 rounded-md text-left w-full"
                      onClick={handleAddLabel}
                      disabled={!isfilterOn}
                    >
                      <TagIcon className="mr-2" fill="#000000" />
                      <span className="text-black">Save this view...</span>
                    </button>
                  </div>
                </Select.Option>
              )}
              <Select.Option disabled key="manage-view">
                <div className="">
                  <button
                    className="flex items-center py-2 px-1 hover:bg-gray-100 rounded-md text-left w-full"
                    type="button"
                    onClick={handleMangeViews}
                  >
                    <ManageViewsIcon className="mr-2" fill="#000000" />
                    <span className="text-black">Manage views...</span>
                  </button>
                </div>
              </Select.Option>
              {Array.isArray(recentSearchList?.search_preference) &&
                recentSearchList?.search_preference.length > 0 && (
                  <Select.Option disabled key="recent-searches-heading">
                    <div className="text-gray-400">My views</div>
                  </Select.Option>
                )}
              {Array.isArray(recentSearchList?.search_preference) &&
                recentSearchList?.search_preference.map((search, index) => {
                  const uniqueKey = `${search?.practitioners
                    .map((p) => p.practitionerId)
                    .join(',')}-${search?.patient}-${
                    search?.date
                  }-${search?.status}-${index}`;
                  return (
                    <Select.Option
                      key={uniqueKey}
                      value={search?.practitioners
                        .map((p) => p.practitionerId)
                        .flat()}
                      label={search?.practitioners
                        .map((p) => p.practitionerName)
                        .join(', ')}
                    >
                      <button
                        type="button"
                        className="w-full text-left py-1"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleRecentSearchSelect(search);
                          setSelectedTitle(search.title);
                          localStorage.setItem(
                            `${currentPractitioner?.org_uuid}_selectedTitle`,
                            search.title
                          );
                          setMyAppointments('');
                        }}
                      >
                        <div className="flex justify-between gap-1 text-wrap">
                          {search?.title && <div>{search?.title}</div>}
                          {search?.isDefaultAppointmentView ? (
                            <div className="flex auraonly-radio-outlook">
                              Default View
                            </div>
                          ) : (
                            <button
                              className="hover:bg-[#E5E8EB] hover:underline underline-offset-2 decoration-black text-black rounded-xl drop-shadow-sm py-[3px] px-[10px] flex items-center shrink-0 font-normal text-[12px]"
                              onClick={() => handleSetDefault(search)}
                            >
                              Set as Default
                            </button>
                          )}
                        </div>
                      </button>
                    </Select.Option>
                  );
                })}
            </Select>

            <SavedSearchModal
              isModalVisible={isModalVisible}
              parseStoredNames={parseStoredNames}
              handleSaveView={handleSaveView}
              handleCloseView={handleCloseView}
              savePatientName={filterValue?.patientName}
              saveDate={filterValue?.datefilter}
              saveStatus={filterValue?.status}
              setRenameTitle={setRenameTitle}
              renameTitle={renameTitle}
              handleSaveAppDuplicate={handleSaveAppDuplicate}
              duplicateError={duplicateError}
              setDuplicateError={setDuplicateError}
              setSelectedTitle={setSelectedTitle}
              setDefaultAppointmentView={setDefaultAppointmentView}
              isDefaultAppointmentView={isDefaultAppointmentView}
            />
            <ManageViewModal
              setRenameTitle={setRenameTitle}
              isMangeViewOpen={isMangeViewOpen}
              handleMangeViews={handleMangeViews}
              handleCloseManageView={handleCloseManageView}
              recentSearchList={recentSearchList}
              renameTitle={renameTitle}
              selectedTitle={selectedTitle}
              setFilterValue={setFilterValue}
              handleReset={handleReset}
              setSelectedTitle={setSelectedTitle}
            />

            {showConvertAppointmentToAuraModal && (
              <ConvertAppointmentToAuraEncounterModal
                showConvertAppointmentToAuraModal={
                  showConvertAppointmentToAuraModal
                }
                selectedAppointmentForAuraEncounter={
                  selectedAppointmentForAuraEncounter
                }
                hideConvertAppointmentToAuraModal={
                  hideConvertAppointmentToAuraModal
                }
                isfilterOn={isfilterOn}
                startIndex={startIndex}
                filterValue={filterValue}
              />
            )}
          </div>
          {/* Recent filter search : end */}

          {/* Reset Icon : start */}
          {(localStorage.getItem(
            `${currentPractitioner?.org_uuid}_selectedFilters`
          ) !== 'Today' ||
            filterValue?.doctorName?.length > 0 ||
            filterValue?.patientName ||
            parseStoredNames?.length > 0 ||
            filterValue?.status) && (
            <div id="ClearFilter">
              <button
                id="clear_filter_appointment"
                type="button"
                className="hover:bg-[#E5E8EB]
                                            hover:underline underline-offset-2 decoration-black text-black rounded-xl drop-shadow-sm px-0.5 py-2.5 h-10 flex items-center  shrink-0 font-normal text-[12px]"
                onClick={() => handleReset('reset')}
              >
                <p className="w-[70px]">Clear filters</p>
              </button>
            </div>
          )}
        </div>

        {/* Reset Icon : end */}
        <div className="flex gap-1">
          <Tooltip title="Toggle appointments view" placement="topRight">
            <div className="settings-component">
              <Radio.Group
                value={appointmentsView}
                onChange={(e) => {
                  handleTabChange(e.target.value);
                }}
                className="flex justify-between items-center cursor-pointer"
              >
                <Radio.Button
                  className="p-2 h-[38px]"
                  key={'LIST'}
                  value={'LIST'}
                >
                  <ListIcon />
                </Radio.Button>

                <Radio.Button
                  className="p-2  h-[38px]"
                  key={'CALENDAR'}
                  value={'CALENDAR'}
                >
                  <CalendarIcon />
                </Radio.Button>
              </Radio.Group>
            </div>
          </Tooltip>

          <div className="">
            {isModalOpen && (
              <AddNewAppointment
                isOpen={isModalOpen}
                onCancel={handleCancel}
                setIsOpen={setIsModalOpen}
                startIndex={startIndex}
                isfilterOn={isfilterOn}
                filterValue={filterValue}
                defaultAppointmentType={defaultAppointmentType}
              />
            )}
            <span style={{ position: 'absolute' }}>
              <AppointmentsCSVUploader
                visible={showUpload}
                setVisible={setShowUpload}
              />
              {showUploadHistory && (
                <AppointmentsCSVUploaderHistory
                  visible={showUploadHistory}
                  setVisible={setShowUploadHistory}
                />
              )}
            </span>
            {CSVUploadEnabledForCurrentUser ? (
              <Dropdown.Button
                type="primary"
                overlay={addAppointmentOptions()}
                placement="bottomLeft"
                id="add_appointment_dropdown"
                rootClassName="add-appointment-dropdown rounded-xl drop-shadow-sm flex bg-[#00D090] hover:bg-[#059669]"
                icon={<ExpandIcon fill={'#ffffff'} />}
                onClick={showModal}
              >
                <div className="add-appointment-div flex">
                  {isShowAppointmentTooltip ? (
                    <Tooltip title="Add appointment" placement="topRight">
                      <span className="text-white text-2xl px-2">+</span>
                    </Tooltip>
                  ) : (
                    <>
                      <PlusIcon className="ml-2" />
                      <span className="text-white px-2 font-normal font-sans">
                        Add appointment
                      </span>
                    </>
                  )}
                </div>
              </Dropdown.Button>
            ) : (
              <button
                className="rounded-xl h-10 items-center p-2 flex bg-[#00D090] hover:bg-[#059669]"
                onClick={showModal}
              >
                <div className="flex items-center">
                  {isShowAppointmentTooltip ? (
                    <Tooltip title="Add appointment" placement="topRight">
                      <span className="text-white text-2xl px-2">+</span>
                    </Tooltip>
                  ) : (
                    <>
                      <PlusIcon className="ml-2" />
                      <span className="text-white px-2 font-normal font-sans">
                        Add appointment
                      </span>
                    </>
                  )}
                </div>
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AppointmentTopFilterBar;
